<script lang="ts">
  import ChooseAgreement from "../components/ChooseAgreement.svelte";
  import QueryClientDecorator from "../helpers/QueryClientDecorator.svelte";
  import { createPurchaseModuleData } from "../helpers/purchaseModuleData.svelte";
  import { getDefaultProductOrder } from "../helpers/helperMethods";

  interface Props {
    location?: string;
    campaign: string;
    productOrder: string[] | null;
  }

  let {
    location = $bindable("/elavtal/teckna"),
    campaign,
    productOrder = $bindable(),
  }: Props = $props();

  if (productOrder == null) {
    productOrder = getDefaultProductOrder();
  }

  // The data factory alone satisfies ChooseAgreementFlow — the module has no
  // screens of its own anymore, so there is no nav factory and no provider.
  const flow = createPurchaseModuleData();

  if (campaign) {
    flow.setCampaign(campaign);
    if (location.charAt(location.length - 1) != "/") {
      location += "/";
    }
    location = location.concat(campaign);
  }
</script>

<QueryClientDecorator>
  <ChooseAgreement
    {flow}
    headerLevel={2}
    onComplete={() => {
      window.location.href = location;
    }}
    estimationText = "Uppskatta din årliga elförbrukning. Du kan antingen ange storleken på ditt boende genom att
                    föra knappen längs linjen eller fylla i förbrukningen i rutan själv om du vet ungefär hur den
                    brukar se ut."
    autoSelectSingle
    {productOrder}
    forceEstimationView={flow.forceShowEstimation}
  />
</QueryClientDecorator>

<!-- This bundle ships its own stylesheet, so emit Tailwind here. -->
<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
</style>
